import React, { useState } from 'react';
import Pagination from '../../Common/Pagination';

export default function SiteLogs({ logs, onShowEntries, hide }) {
    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric" });
    const [isClosed, setIsClosed] = useState(false);
    const [selectedPage, setSelectedPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    function handleSelectPage(pageNum) {
        setSelectedPage(pageNum);
    }

    let shownStartIndex = (pageSize * selectedPage) - pageSize;
    let shownEndIndex = (pageSize * selectedPage);

    let logListItems = !isClosed && logs && logs
        .map((log, index) => <tr className={index < shownStartIndex || index >= shownEndIndex ? "hidden" : "" } key={log.id}>
            <td>{log.description}</td>
            <td className="tabular-nums">{log.activeDate && dateFormatter.format(new Date(log.activeDate))}</td>
            <td className="tabular-nums">{log.inactiveDate && dateFormatter.format(new Date(log.inactiveDate))}</td>
            <td>{log.comments}</td>
            <td className="tabular-nums">{log.updatedDate && dateFormatter.format(new Date(log.updatedDate))}</td>
            <td className="compact"><button className="button" onClick={() => onShowEntries(log.id)}>View</button></td>
            <td className="smallScreen">
                <div className="log">
                    {log.activeDate && (<div>
                        <span className="fieldDesc">Active On:</span>
                        {log.activeDate && dateFormatter.format(new Date(log.activeDate))}
                    </div>)}
                    {log.inactiveDate && (<div>
                        <span className="fieldDesc">Inactive On:</span>
                        {log.inactiveDate && dateFormatter.format(new Date(log.inactiveDate))}
                    </div>)}
                    {log.updatedDate && (<div>
                        <span className="fieldDesc">Updated On:</span>
                        {log.updatedDate && dateFormatter.format(new Date(log.updatedDate))}
                    </div>)}
                    {log.description && (<div>
                        <span className="fieldDesc">Description:</span>
                        <div className="desc">{log.description}</div>
                    </div>)}
                    {log.comments && (<div>
                        <span className="fieldDesc">Comments:</span>
                        <div className="desc">{log.comments}</div>
                    </div>)}
                    <div className="buttonContainer">
                        <button className="button" onClick={() => onShowEntries(log.id)}>View</button>
                    </div>
                </div>
            </td>
        </tr>);

    if (selectedPage > 1 && (pageSize * selectedPage) - logListItems.length > 0) {
        let emptyRows = Array.from(
            { length: (pageSize * selectedPage) - logListItems.length },
            (cv, i) => (<tr className="noBkg noPrint" key={`R${i}`}><td><button className="button hide">&nbsp;</button></td></tr>));
        logListItems = logListItems.concat(emptyRows);
    }

    let logList = logListItems.length === 0 ? undefined : !isClosed && (<>
        <table id="logList" className="itemList">
            <thead>
                <tr>
                    <th>Description</th>
                    <th className="date">Active On</th>
                    <th className="date">Inactive On</th>
                    <th>Comments</th>
                    <th className="date">Updated On</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>{logListItems}</tbody>
        </table>
        <Pagination itemCount={logs.length} pageSize={pageSize} selectedPage={selectedPage} hideWhenSinglePage={false} onSelectPage={handleSelectPage} />
    </>);

    let hideClass = hide && "hidden"

    return (
        <div className={`logTypeContainer ${hideClass}`}>
            {logList}
        </div>
    );
}